import RouteTemplate from 'ember-route-template';
import { on } from '@ember/modifier';
import { fn, concat } from '@ember/helper';
import { Input } from '@ember/component';
import AdminProviderManager from '../../components/admin-provider-manager';
import eq from 'truth-helpers/helpers/eq';
import lte from 'truth-helpers/helpers/lte';
import gte from 'truth-helpers/helpers/gte';
export default RouteTemplate(
  <template>
    <div class="proxyviews-admin-dashboard">
      <div class="pd-admin-header">
        <div class="header-title-wrapper">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.5" class="header-icon"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
          <div>
            <h2>ProxyViews Directory Management</h2>
            <p class="description">Manage directory providers, claims, calculator pricing tiers, and global system settings.</p>
          </div>
        </div>
      </div>
    
      <div class="pd-admin-tabs">
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'overview') 'active'}}" {{on "click" (fn @controller.changeTab 'overview')}}>
          Overview
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'curation') 'active'}}" {{on "click" (fn @controller.changeTab 'curation')}}>
          Curation Directory
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'claims') 'active'}}" {{on "click" (fn @controller.changeTab 'claims')}}>
          Claims Queue ({{@controller.claims.length}})
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'calculator') 'active'}}" {{on "click" (fn @controller.changeTab 'calculator')}}>
          Calculator Pricing
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'settings') 'active'}}" {{on "click" (fn @controller.changeTab 'settings')}}>
          Settings
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'backup') 'active'}}" {{on "click" (fn @controller.changeTab 'backup')}}>
          Backup
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'featured') 'active'}}" {{on "click" (fn @controller.changeTab 'featured')}}>
          Featured
        </button>
        <button type="button" class="pd-admin-tab-btn {{if (eq @controller.activeTab 'edits') 'active'}}" {{on "click" (fn @controller.changeTab 'edits')}}>
          Edit Queue
        </button>
      </div>
    
      {{#if @controller.message}}
        <div class="pd-toast show {{if (eq @controller.message.type 'danger') 'error'}}">{{@controller.message.text}}</div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'overview')}}
        <p class="description">
          Things waiting on you across ProxyViews, in one place — instead of clicking through every plugin's
          admin page to check.
        </p>
    
        <div class="pd-admin-stats">
          <button type="button" class="pd-admin-stat-card pd-overview-card" {{on "click" (fn @controller.changeTab 'claims')}}>
            <div class="stat-header"><span class="label">Provider Claims Pending</span></div>
            <span class="value">{{@controller.overview.provider_claims_pending}}</span>
            <span class="pd-overview-card__link">Review in Claims Queue &rarr;</span>
          </button>
    
          {{#if @controller.reviewsAvailable}}
            <a href="/admin/plugins/proxyviews-reviews" class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Reviews Pending</span></div>
              <span class="value">{{@controller.overview.reviews_pending}}</span>
              <span class="pd-overview-card__link">Open Reviews Moderation &rarr;</span>
            </a>
            <a href="/admin/plugins/proxyviews-reviews" class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Reviews Reported</span></div>
              <span class="value">{{@controller.overview.reviews_reported}}</span>
              <span class="pd-overview-card__link">Open Reviews Moderation &rarr;</span>
            </a>
          {{else}}
            <div class="pd-admin-stat-card pd-overview-card pd-overview-card--disabled">
              <div class="stat-header"><span class="label">Reviews Pending / Reported</span></div>
              <span class="value">—</span>
              <span class="pd-overview-card__link">proxyviews-reviews not enabled</span>
            </div>
          {{/if}}
    
          {{#if @controller.governanceAvailable}}
            <a href="/admin/plugins/proxyviews-governance" class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Proposals Pending</span></div>
              <span class="value">{{@controller.overview.governance_proposals_pending}}</span>
              <span class="pd-overview-card__link">Open Governance &rarr;</span>
            </a>
            <a href="/admin/plugins/proxyviews-governance" class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Comparison Requests Pending</span></div>
              <span class="value">{{@controller.overview.governance_comparison_requests_pending}}</span>
              <span class="pd-overview-card__link">Open Governance &rarr;</span>
            </a>
          {{else}}
            <div class="pd-admin-stat-card pd-overview-card pd-overview-card--disabled">
              <div class="stat-header"><span class="label">Proposals / Comparison Requests</span></div>
              <span class="value">—</span>
              <span class="pd-overview-card__link">proxyviews-governance not enabled</span>
            </div>
          {{/if}}
    
          {{#if @controller.overview.featured_purchases_active}}
            <div class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Featured Purchases Active</span></div>
              <span class="value">{{@controller.overview.featured_purchases_active}}</span>
            </div>
          {{/if}}
    
          {{#if @controller.overview.providers_updated_this_week}}
            <div class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Providers Updated This Week</span></div>
              <span class="value">{{@controller.overview.providers_updated_this_week}}</span>
            </div>
          {{/if}}
    
          {{#if @controller.overview.premium_subscribers_active}}
            <div class="pd-admin-stat-card pd-overview-card">
              <div class="stat-header"><span class="label">Premium Subscribers Active</span></div>
              <span class="value">{{@controller.overview.premium_subscribers_active}}</span>
            </div>
          {{/if}}
        </div>
    
        <div class="pd-admin-table-container" style="margin-top:24px;">
          <h3 style="margin:0 0 12px;font-size:1.15rem;font-weight:700;color:var(--pd-ink)">Recent Activity</h3>
          {{#if @controller.overview.recent_activity}}
            <div class="pd-admin-table-container">
              <table class="pd-admin-table">
                <thead>
                  <tr>
                    <th scope="col">Field</th>
                    <th scope="col">Provider</th>
                    <th scope="col">Description</th>
                    <th scope="col">Who</th>
                    <th scope="col">When</th>
                  </tr>
                </thead>
                <tbody>
                  {{#each @controller.overview.recent_activity as |act|}}
                    <tr>
                      <td><strong>{{act.field}}</strong></td>
                      <td>{{act.provider_name}}</td>
                      <td class="description-text">{{act.description}}</td>
                      <td>{{act.triggered_by}}</td>
                      <td class="description-text">{{act.occurred_at}}</td>
                    </tr>
                  {{/each}}
                </tbody>
              </table>
            </div>
          {{else}}
            <p class="description">No recent activity recorded.</p>
          {{/if}}
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'curation')}}
        <AdminProviderManager />
      {{/if}}
    
      {{#if (eq @controller.activeTab 'claims')}}
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Claimant</th>
                <th scope="col">Provider Slug</th>
                <th scope="col">Company Email</th>
                <th scope="col">Verification URL</th>
                <th scope="col">Notes</th>
                <th scope="col">Curation Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.claims as |c|}}
                <tr>
                  <td>
                    <div class="user-info">
                      <strong>{{c.user.username}}</strong>
                      <span class="email">{{c.user.email}}</span>
                    </div>
                  </td>
                  <td><strong>{{c.provider.name}}</strong> <span class="slug">({{c.provider.slug}})</span></td>
                  <td><a href="mailto:{{c.company_email}}">{{c.company_email}}</a></td>
                  <td>
                    {{#if c.verification_url}}
                      <a href="{{c.verification_url}}" target="_blank" rel="noopener noreferrer" class="claim-link">View Proof &rarr;</a>
                    {{else}}
                      <span class="muted">No URL</span>
                    {{/if}}
                  </td>
                  <td><span class="claim-notes">{{c.notes}}</span></td>
                  <td>
                    <div class="claim-action-buttons">
                      <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'claim-approve-' c.id)) 'disabled'}}" {{on "click" (fn @controller.approveClaim c)}}>
                        Approve
                      </button>
                      <div class="rejection-box">
                        <input type="text" placeholder="Reason..." class="rejection-reason-input" {{on "input" (fn @controller.updateRejectReason c.id)}} />
                        <button type="button" class="btn btn-danger btn-small {{if (eq @controller.savingId (concat 'claim-reject-' c.id)) 'disabled'}}" {{on "click" (fn @controller.rejectClaim c)}}>
                          Reject
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              {{else}}
                <tr>
                  <td colspan="6" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">No pending claims in the verification queue.</p>
                    </div>
                  </td>
                </tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'calculator')}}
        <div class="calculator-sections-container">
          <div class="pd-admin-filter-bar" style="margin-bottom:16px;">
            <button
              type="button"
              class="btn btn-default btn-small {{if (eq @controller.savingId 'seed-calculator') 'disabled'}}"
              {{on "click" @controller.seedCalculator}}
            >
              {{if (eq @controller.savingId 'seed-calculator') "Seeding..." "Seed Calculator Defaults"}}
            </button>
          </div>
    
          <h3>
            Bandwidth Price Tiers
            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.toggleNewTierForm}}>
              {{if @controller.showNewTierForm "Cancel" "+ New Tier"}}
            </button>
          </h3>
    
          {{#if @controller.showNewTierForm}}
            <div class="pd-admin-new-provider-form">
              <select {{on "change" (fn @controller.updateNewTierField "proxy_type")}}>
                {{#each @controller.calculatorProxyTypeOptions as |t|}}
                  <option value={{t}} selected={{eq @controller.newTier.proxy_type t}}>{{t}}</option>
                {{/each}}
              </select>
              <input type="text" placeholder="Label (e.g. Starter)" value={{@controller.newTier.tier_label}} class="input-medium" {{on "input" (fn @controller.updateNewTierField "tier_label")}} />
              <input type="number" placeholder="Min GB" value={{@controller.newTier.min_bandwidth_gb}} class="input-small" {{on "input" (fn @controller.updateNewTierField "min_bandwidth_gb")}} />
              <input type="number" placeholder="Max GB" value={{@controller.newTier.max_bandwidth_gb}} class="input-small" {{on "input" (fn @controller.updateNewTierField "max_bandwidth_gb")}} />
              <input type="number" placeholder="Price/GB" value={{@controller.newTier.price_per_gb}} class="input-small" {{on "input" (fn @controller.updateNewTierField "price_per_gb")}} />
              <input type="number" placeholder="Connections" value={{@controller.newTier.connections_included}} class="input-small" {{on "input" (fn @controller.updateNewTierField "connections_included")}} />
              <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'new-tier') 'disabled'}}" {{on "click" @controller.createPricingTier}}>
                {{if (eq @controller.savingId 'new-tier') "Creating..." "Create"}}
              </button>
            </div>
          {{/if}}
    
          <div class="pd-admin-table-container margin-bottom-lg">
<table class="pd-admin-table">
              <thead>
                <tr>
                  <th scope="col">Type</th>
                  <th scope="col">Label</th>
                  <th scope="col">Min GB</th>
                  <th scope="col">Max GB</th>
                  <th scope="col">Price/GB</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {{#each @controller.pricingTiers as |t|}}
                  <tr class="{{if (eq @controller.editingCalcId t.id) 'pd-row-editing'}}">
                    <td><span class="badge badge-type">{{t.proxy_type}}</span></td>
                    <td>{{t.tier_label}}</td>
                    <td>{{t.min_bandwidth_gb}}</td>
                    <td>{{t.max_bandwidth_gb}}</td>
                    <td>${{t.price_per_gb}}</td>
                    <td>
                      <label class="pd-switch">
                        <input type="checkbox" checked={{t.active}} {{on "change" (fn @controller.togglePricingTierActive t)}} />
                        <span class="pd-slider"></span>
                      </label>
                    </td>
                    <td class="pd-admin-actions-cell">
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditTier t)}}>
                        {{if (eq @controller.editingCalcId t.id) "Editing..." "Edit"}}
                      </button>
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deletePricingTier t)}}>
                        Delete
                      </button>
                    </td>
                  </tr>
                  {{#if (eq @controller.editingCalcId t.id)}}
                    <tr class="pd-edit-row">
                      <td colspan="7">
                        <div class="pd-edit-row__panel">
                          <h4>Edit Tier — {{t.tier_label}}</h4>
                          <div class="pd-edit-row__fields">
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Label</label>
                              <input type="text" value={{@controller.calcDraft.tier_label}} {{on "input" (fn @controller.updateCalcDraft "tier_label")}} class="input-medium" />
                            </div>
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Min GB</label>
                              <input type="number" value={{@controller.calcDraft.min_bandwidth_gb}} {{on "input" (fn @controller.updateCalcDraft "min_bandwidth_gb")}} class="input-small" />
                            </div>
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Max GB</label>
                              <input type="number" value={{@controller.calcDraft.max_bandwidth_gb}} {{on "input" (fn @controller.updateCalcDraft "max_bandwidth_gb")}} class="input-small" />
                            </div>
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Price/GB</label>
                              <input type="number" step="0.01" value={{@controller.calcDraft.price_per_gb}} {{on "input" (fn @controller.updateCalcDraft "price_per_gb")}} class="input-small" />
                            </div>
                          </div>
                          <div class="pd-edit-row__actions">
                            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.cancelEditCalc}}>Cancel</button>
                            <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'pricing-' t.id)) 'disabled'}}" {{on "click" (fn @controller.savePricingTier t)}}>
                              {{if (eq @controller.savingId (concat 'pricing-' t.id)) "Saving..." "Save Changes"}}
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  {{/if}}
                {{else}}
                  <tr>
                    <td colspan="7" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">No pricing tiers yet.</p>
                    </div></td>
                  </tr>
                {{/each}}
              </tbody>
            </table>
</div>
          </div>
    
          <h3>
            Region Multipliers
            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.toggleNewRegionForm}}>
              {{if @controller.showNewRegionForm "Cancel" "+ New Region"}}
            </button>
          </h3>
    
          {{#if @controller.showNewRegionForm}}
            <div class="pd-admin-new-provider-form">
              <input type="text" placeholder="Region name" value={{@controller.newRegion.region_name}} class="input-medium" {{on "input" (fn @controller.updateNewRegionField "region_name")}} />
              <input type="text" placeholder="Code (e.g. EU)" value={{@controller.newRegion.region_code}} class="input-small" {{on "input" (fn @controller.updateNewRegionField "region_code")}} />
              <select {{on "change" (fn @controller.updateNewRegionField "proxy_type")}}>
                {{#each @controller.calculatorProxyTypeOptions as |t|}}
                  <option value={{t}} selected={{eq @controller.newRegion.proxy_type t}}>{{t}}</option>
                {{/each}}
              </select>
              <input type="number" step="0.01" placeholder="Multiplier" value={{@controller.newRegion.multiplier}} class="input-small" {{on "input" (fn @controller.updateNewRegionField "multiplier")}} />
              <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'new-region') 'disabled'}}" {{on "click" @controller.createRegion}}>
                {{if (eq @controller.savingId 'new-region') "Creating..." "Create"}}
              </button>
            </div>
          {{/if}}
    
          <div class="pd-admin-table-container margin-bottom-lg">
<table class="pd-admin-table">
              <thead>
                <tr>
                  <th scope="col">Region Name</th>
                  <th scope="col">Code</th>
                  <th scope="col">Type</th>
                  <th scope="col">Multiplier</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {{#each @controller.regions as |r|}}
                  <tr class="{{if (eq @controller.editingCalcId r.id) 'pd-row-editing'}}">
                    <td><strong>{{r.region_name}}</strong></td>
                    <td><span class="badge">{{r.region_code}}</span></td>
                    <td><span class="badge badge-type">{{r.proxy_type}}</span></td>
                    <td>{{r.multiplier}}</td>
                    <td>
                      <label class="pd-switch">
                        <input type="checkbox" checked={{r.active}} {{on "change" (fn @controller.toggleRegionActive r)}} />
                        <span class="pd-slider"></span>
                      </label>
                    </td>
                    <td class="pd-admin-actions-cell">
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditRegion r)}}>
                        {{if (eq @controller.editingCalcId r.id) "Editing..." "Edit"}}
                      </button>
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteRegion r)}}>
                        Delete
                      </button>
                    </td>
                  </tr>
                  {{#if (eq @controller.editingCalcId r.id)}}
                    <tr class="pd-edit-row">
                      <td colspan="6">
                        <div class="pd-edit-row__panel">
                          <h4>Edit Region — {{r.region_name}}</h4>
                          <div class="pd-edit-row__fields">
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Multiplier</label>
                              <input type="number" step="0.01" value={{@controller.calcDraft.multiplier}} {{on "input" (fn @controller.updateCalcDraft "multiplier")}} class="input-small" />
                            </div>
                          </div>
                          <div class="pd-edit-row__actions">
                            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.cancelEditCalc}}>Cancel</button>
                            <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'region-' r.id)) 'disabled'}}" {{on "click" (fn @controller.saveRegionMultiplier r)}}>
                              {{if (eq @controller.savingId (concat 'region-' r.id)) "Saving..." "Save Changes"}}
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  {{/if}}
                {{else}}
                  <tr>
                    <td colspan="6" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">No regions yet.</p>
                    </div></td>
                  </tr>
                {{/each}}
              </tbody>
            </table>
</div>
    
          <h3>
            Provider Pricing Overrides
            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.toggleNewProviderPricingForm}}>
              {{if @controller.showNewProviderPricingForm "Cancel" "+ New Override"}}
            </button>
            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.toggleBulkPriceForm}}>
              {{if @controller.showBulkPriceForm "Cancel" "Bulk Edit"}}
            </button>
          </h3>
          <p class="description">Per-provider price/GB and region multiplier overrides that take precedence over the bandwidth tiers above for that specific provider.</p>
    
          {{#if @controller.showBulkPriceForm}}
            <div class="pd-admin-new-provider-form">
              <input type="number" step="0.01" placeholder="Price/GB for all" value={{@controller.bulkPriceValue}} class="input-small" {{on "input" (fn @controller.updateBulkPriceField "price")}} />
              <input type="number" step="0.01" placeholder="Region multiplier (optional)" value={{@controller.bulkMultiplierValue}} class="input-small" {{on "input" (fn @controller.updateBulkPriceField "multiplier")}} />
              <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'bulk-pricing') 'disabled'}}" {{on "click" @controller.bulkApplyPrice}}>
                {{if (eq @controller.savingId 'bulk-pricing') "Applying..." "Apply to All"}}
              </button>
            </div>
          {{/if}}
    
          {{#if @controller.showNewProviderPricingForm}}
            <div class="pd-admin-new-provider-form">
              <select {{on "change" (fn @controller.updateNewProviderPricingField "provider_id")}}>
                <option value="">Select provider…</option>
                {{#each @controller.allProviders as |p|}}
                  <option value={{p.id}} selected={{eq @controller.newProviderPricing.provider_id p.id}}>{{p.name}}</option>
                {{/each}}
              </select>
              <select {{on "change" (fn @controller.updateNewProviderPricingField "proxy_type")}}>
                {{#each @controller.calculatorProxyTypeOptions as |t|}}
                  <option value={{t}} selected={{eq @controller.newProviderPricing.proxy_type t}}>{{t}}</option>
                {{/each}}
              </select>
              <input type="number" step="0.0001" placeholder="Price/GB" value={{@controller.newProviderPricing.price_per_gb}} class="input-small" {{on "input" (fn @controller.updateNewProviderPricingField "price_per_gb")}} />
              <input type="number" step="0.01" placeholder="Region multiplier" value={{@controller.newProviderPricing.region_multiplier}} class="input-small" {{on "input" (fn @controller.updateNewProviderPricingField "region_multiplier")}} />
              <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'new-provider-pricing') 'disabled'}}" {{on "click" @controller.createProviderPricing}}>
                {{if (eq @controller.savingId 'new-provider-pricing') "Creating..." "Create"}}
              </button>
            </div>
          {{/if}}
    
          <div class="pd-admin-table-container">
<table class="pd-admin-table">
              <thead>
                <tr>
                  <th scope="col">Provider</th>
                  <th scope="col">Type</th>
                  <th scope="col">Price/GB</th>
                  <th scope="col">Region Multiplier</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {{#each @controller.providerPricings as |pp|}}
                  <tr class="{{if (eq @controller.editingCalcId pp.id) 'pd-row-editing'}}">
                    <td><strong>{{pp.provider_name}}</strong> <span class="slug">({{pp.provider_slug}})</span></td>
                    <td><span class="badge badge-type">{{pp.proxy_type}}</span></td>
                    <td>${{pp.price_per_gb}}</td>
                    <td>{{pp.region_multiplier}}</td>
                    <td>
                      <label class="pd-switch">
                        <input type="checkbox" checked={{pp.active}} {{on "change" (fn @controller.toggleProviderPricingActive pp)}} />
                        <span class="pd-slider"></span>
                      </label>
                    </td>
                    <td class="pd-admin-actions-cell">
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditProviderPricing pp)}}>
                        {{if (eq @controller.editingCalcId pp.id) "Editing..." "Edit"}}
                      </button>
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteProviderPricing pp)}}>
                        Delete
                      </button>
                    </td>
                  </tr>
                  {{#if (eq @controller.editingCalcId pp.id)}}
                    <tr class="pd-edit-row">
                      <td colspan="6">
                        <div class="pd-edit-row__panel">
                          <h4>Edit Override — {{pp.provider_name}}</h4>
                          <div class="pd-edit-row__fields">
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Type</label>
                              <select {{on "change" (fn @controller.updateCalcDraft "proxy_type")}}>
                                {{#each @controller.calculatorProxyTypeOptions as |t|}}
                                  <option value={{t}} selected={{eq @controller.calcDraft.proxy_type t}}>{{t}}</option>
                                {{/each}}
                              </select>
                            </div>
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Price/GB</label>
                              <input type="number" step="0.0001" value={{@controller.calcDraft.price_per_gb}} {{on "input" (fn @controller.updateCalcDraft "price_per_gb")}} class="input-small" />
                            </div>
                            <div class="pd-edit-row__field">
                              <label class="pd-sidebar-label">Region Multiplier</label>
                              <input type="number" step="0.01" value={{@controller.calcDraft.region_multiplier}} {{on "input" (fn @controller.updateCalcDraft "region_multiplier")}} class="input-small" />
                            </div>
                          </div>
                          <div class="pd-edit-row__actions">
                            <button type="button" class="btn btn-default btn-small" {{on "click" @controller.cancelEditCalc}}>Cancel</button>
                            <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'provider-pricing-' pp.id)) 'disabled'}}" {{on "click" (fn @controller.saveProviderPricing pp)}}>
                              {{if (eq @controller.savingId (concat 'provider-pricing-' pp.id)) "Saving..." "Save Changes"}}
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  {{/if}}
                {{else}}
                  <tr>
                    <td colspan="6" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">No provider pricing overrides yet.</p>
                    </div></td>
                  </tr>
                {{/each}}
              </tbody>
            </table>
</div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'settings')}}
        <div class="pd-admin-section-title-wrapper" style="margin-top: 0px; margin-bottom: 16px;">
          <h3 style="margin: 0; font-size: 1.15rem; font-weight: 700; color: var(--pd-ink);">Platform & Feature Settings</h3>
          <p style="margin: 4px 0 0 0; font-size: 0.8rem; color: var(--pd-muted);">Toggle core plugin modules and permissions for Directory, Reviews, SEO, and Premium membership features.</p>
        </div>

        <div class="pd-admin-table-container" style="margin-bottom: 32px;">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Setting</th>
                <th scope="col">Module</th>
                <th scope="col">Value</th>
                <th scope="col">Description</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.siteSettings as |s|}}
                <tr>
                  <td><strong>{{s.key}}</strong></td>
                  <td><span class="badge badge-type">{{s.category}}</span></td>
                  <td>
                    {{#if (eq s.value_type "boolean")}}
                      <button
                        type="button"
                        class="pd-admin-toggle {{if s.value 'pd-admin-toggle--on'}}"
                        disabled={{eq @controller.savingId (concat "site-setting-" s.key)}}
                        {{on "click" (fn @controller.toggleSiteSetting s)}}
                        aria-label={{s.key}}
                        title={{if s.value "Click to disable" "Click to enable"}}
                      >
                        <span class="pd-admin-toggle__track">
                          <span class="pd-admin-toggle__thumb"></span>
                        </span>
                      </button>
                    {{else if (eq s.value_type "integer")}}
                      <input type="number" value={{s.value}} class="input-small" {{on "input" (fn @controller.updateSiteSettingValue s)}} />
                    {{else if (eq s.value_type "secret")}}
                      <input type="password" value={{s.value}} class="input-medium" placeholder="Enter new value to replace" {{on "input" (fn @controller.updateSiteSettingValue s)}} />
                    {{else}}
                      <input type="text" value={{s.value}} class="input-medium" {{on "input" (fn @controller.updateSiteSettingValue s)}} />
                    {{/if}}
                  </td>
                  <td><span class="description-text">{{s.description}}</span></td>
                  <td class="pd-admin-actions-cell">
                    <div class="pd-admin-actions-group">
                      {{#unless (eq s.value_type "boolean")}}
                        <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'site-setting-' s.key)) 'disabled'}}" {{on "click" (fn @controller.saveSiteSettingValue s)}}>
                          {{if (eq @controller.savingId (concat 'site-setting-' s.key)) "Saving..." "Save"}}
                        </button>
                      {{/unless}}
                    </div>
                  </td>
                </tr>
              {{/each}}
            </tbody>
          </table>
        </div>

        {{! Calculator parameters merged into the Settings table }}
        <h4 style="margin: 24px 0 8px; font-size: 1rem; font-weight: 700; color: var(--pd-ink);">Calculator Parameters</h4>
        <div class="pd-admin-table-container" style="margin-bottom: 32px;">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Setting Key</th>
                <th scope="col">Type</th>
                <th scope="col">Value</th>
                <th scope="col">Description</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.settings as |s|}}
                <tr>
                  <td><strong>{{s.key}}</strong></td>
                  <td><span class="badge badge-type">{{s.value_type}}</span></td>
                  <td><Input @value={{s.value}} class="input-medium" /></td>
                  <td><span class="description-text">{{s.description}}</span></td>
                  <td class="pd-admin-actions-cell">
                    <div class="pd-admin-actions-group">
                      <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'setting-' s.id)) 'disabled'}}" {{on "click" (fn @controller.saveSetting s)}}>
                        {{if (eq @controller.savingId (concat 'setting-' s.id)) 'Saving...' 'Save'}}
                      </button>
                    </div>
                  </td>
                </tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'backup')}}
        <div class="calculator-sections-container" style="margin-bottom: 24px;">
          <div style="display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 16px;">
            <div>
              <h3 style="margin: 0 0 6px 0; font-size: 1.15rem; font-weight: 700; color: var(--pd-ink);">System Backup & Content Portability</h3>
              <p class="description" style="margin: 0; max-width: 720px;">
                Export or restore content &amp; workflow data across all ProxyViews plugins (Providers, Guides, Comparisons, Benchmark Runs, Pricing Tiers, Settings, Funnels, A/B Experiments) as a portable JSON file.
                Leaves out high-volume telemetry &amp; payment secret keys. For full database dumps, use <a href="/admin/backups" target="_blank" rel="noopener noreferrer">Admin &gt; Backups ↗</a>.
              </p>
            </div>
            <div class="pd-backup-actions" style="display: flex; flex-wrap: wrap; gap: 8px;">
              <a
                href="/admin/plugins/proxyviews-directory/backup/export"
                target="_blank"
                rel="noopener noreferrer"
                download="proxyviews-backup-full.json"
                class="btn btn-primary btn-small"
                title="Export all 21 system data tables"
              >
                📥 Export Full Backup (JSON)
              </a>
              <a
                href="/admin/plugins/proxyviews-directory/backup/export?sections=providers,calculator_settings,calculator_pricing_tiers,calculator_region_multipliers,calculator_provider_pricing"
                target="_blank"
                rel="noopener noreferrer"
                download="proxyviews-backup-directory.json"
                class="btn btn-default btn-small"
                title="Export Directory & Pricing parameters only"
              >
                📁 Directory &amp; Pricing
              </a>
              <a
                href="/admin/plugins/proxyviews-directory/backup/export?sections=guides,guide_custom_categories,comparisons,best_for_use_cases,alternative_metadata,seo_robots_config"
                target="_blank"
                rel="noopener noreferrer"
                download="proxyviews-backup-seo.json"
                class="btn btn-default btn-small"
                title="Export SEO Guides, Comparisons & Best For content only"
              >
                🔍 SEO Content
              </a>
              <a href="/admin/backups" target="_blank" rel="noopener noreferrer" class="btn btn-default btn-small">
                ⚙️ Core Discourse ↗
              </a>
            </div>
          </div>
        </div>

        <div style="margin-bottom: 28px;">
          <h4 style="margin: 0 0 12px 0; font-size: 0.95rem; font-weight: 700; color: var(--pd-ink); text-transform: uppercase; letter-spacing: 0.04em;">Available Data Footprint</h4>
          <div class="pd-admin-stats">
            {{#each @controller.backupSummaryRows as |row|}}
              <div class="pd-admin-stat-card {{unless row.available 'pd-overview-card--disabled'}}">
                <div class="stat-header">
                  <span class="label">{{row.label}}</span>
                </div>
                <span class="value">{{if row.available row.count "—"}}</span>
                {{#unless row.available}}
                  <span class="pd-overview-card__link">plugin disabled</span>
                {{/unless}}
              </div>
            {{/each}}
          </div>
        </div>

        <div class="calculator-sections-container pd-admin-form-panel">
          <div class="pd-admin-form-panel__header">
            <h3>🔄 Restore / Import Data</h3>
            <span class="pd-admin-form-panel__hint">Idempotent natural-key upserts with pre-flight inspection</span>
          </div>

          <p class="description" style="margin-bottom: 16px;">
            Upload a previously exported ProxyViews JSON file. Inspect payload details before committing. Providers, guides, comparisons, calculator parameters, and benchmark runs will be safely upserted without duplicate rows.
          </p>

          {{#if @controller.pendingBackupPreview}}
            <div class="pd-backup-inspection-card" style="padding: 20px; background: var(--primary-very-low); border: 2px dashed var(--pd-blue-vivid, #2563eb); border-radius: 12px; margin-bottom: 20px;">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
                <h4 style="margin: 0; font-size: 1.05rem; font-weight: 700; color: var(--pd-ink);">📋 Pre-Import Payload Inspection</h4>
                <span class="badge badge-type" style="background: var(--pd-blue-vivid, #2563eb); color: white; padding: 4px 10px;">
                  Ready to Restore: {{@controller.pendingBackupPreview.totalRecords}} Records
                </span>
              </div>

              <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-bottom: 16px; font-size: 0.85rem; color: var(--pd-muted);">
                <div><strong>File Name:</strong> {{@controller.pendingBackupPreview.fileName}}</div>
                <div><strong>File Size:</strong> {{@controller.pendingBackupPreview.fileSizeFormatted}}</div>
                <div><strong>Exported At:</strong> {{@controller.pendingBackupPreview.exportedAt}}</div>
                <div><strong>Source Domain:</strong> {{@controller.pendingBackupPreview.sourceUrl}}</div>
              </div>

              <h5 style="margin: 0 0 8px 0; font-size: 0.85rem; font-weight: 700; color: var(--pd-ink); text-transform: uppercase;">Included Sections Breakdown</h5>
              <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 20px;">
                {{#each @controller.pendingBackupSectionsList as |item|}}
                  <span class="badge badge-type" style="background: var(--primary-low); color: var(--primary-high);">
                    {{item.key}}: {{item.count}}
                  </span>
                {{/each}}
              </div>

              <div style="display: flex; gap: 10px;">
                <button
                  type="button"
                  class="btn btn-primary"
                  disabled={{eq @controller.savingId 'import'}}
                  {{on "click" @controller.confirmAndExecuteImport}}
                >
                  {{if (eq @controller.savingId 'import') "Restoring Database..." "🚀 Confirm & Execute Import"}}
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  disabled={{eq @controller.savingId 'import'}}
                  {{on "click" @controller.cancelPendingBackup}}
                >
                  Cancel
                </button>
              </div>
            </div>
          {{else}}
            <div
              class="pd-backup-dropzone {{if @controller.isDraggingBackup 'pd-backup-dropzone--active'}}"
              {{on "dragover" @controller.handleBackupDragOver}}
              {{on "dragleave" @controller.handleBackupDragLeave}}
              {{on "drop" @controller.handleBackupDrop}}
            >
              <div class="pd-backup-dropzone__content">
                <span class="pd-backup-dropzone__icon">📄</span>
                <p class="pd-backup-dropzone__title">
                  {{if @controller.isDraggingBackup "Drop JSON file to inspect..." "Drag & drop backup JSON file here"}}
                </p>
                <span class="pd-backup-dropzone__subtitle">or choose a file from your computer to inspect payload</span>

                <label class="btn btn-default btn-small pd-backup-dropzone__btn">
                  <span>Select JSON File</span>
                  <input
                    type="file"
                    accept="application/json,.json"
                    disabled={{eq @controller.savingId 'import'}}
                    style="display: none;"
                    {{on "change" @controller.handleBackupFileSelect}}
                  />
                </label>

                {{#if (eq @controller.savingId 'import')}}
                  <div class="pd-backup-dropzone__loading" style="margin-top: 12px; color: var(--pd-blue-vivid); font-weight: 600;">
                    <span class="spinner small" style="margin-right: 6px;"></span> Restoring content and validating payload…
                  </div>
                {{/if}}
              </div>
            </div>
          {{/if}}

          {{#if @controller.importResult}}
            <div class="pd-backup-report" style="margin-top: 20px; padding: 16px; background: var(--primary-very-low); border: 1px solid var(--primary-low); border-radius: 8px;">
              <h4 style="margin: 0 0 10px 0; font-size: 0.95rem; font-weight: 700; color: var(--pd-ink);">Import Summary Report</h4>
              <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                {{#each @controller.importResultList as |item|}}
                  <span class="badge badge-type" style="background: #10b981; color: white;">
                    ✓ {{item.key}}: {{item.count}} restored
                  </span>
                {{/each}}
              </div>
            </div>
          {{/if}}
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'featured')}}
        <div class="pd-admin-filter-bar" style="margin-bottom:16px;">
          <button
            type="button"
            class="btn btn-default btn-small {{if (eq @controller.savingId 'cleanup-featured') 'disabled'}}"
            {{on "click" @controller.cleanupFeatured}}
          >
            {{if (eq @controller.savingId 'cleanup-featured') "Cleaning..." "Cleanup Expired"}}
          </button>
        </div>
    
        <div class="pd-admin-table-container">
          <div class="pd-admin-table-container">
<table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Provider</th>
                <th scope="col">Purchaser</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Starts</th>
                <th scope="col">Expires</th>
                <th scope="col">Stripe Session</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#if @controller.featuredPurchasesLoading}}
                <tr><td colspan="8" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">Loading featured purchases…</p>
                    </div></td></tr>
              {{else}}
                {{#each @controller.featuredPurchases as |fp|}}
                  <tr>
                    <td><strong>{{fp.provider_name}}</strong></td>
                    <td>{{fp.purchaser_username}}</td>
                    <td>{{fp.amount_paid}}</td>
                    <td><span class="badge badge-type">{{fp.status}}</span></td>
                    <td class="description-text">{{fp.start_date}}</td>
                    <td class="description-text">{{fp.end_date}}</td>
                    <td class="description-text">{{fp.stripe_session_id}}</td>
                    <td class="pd-admin-actions-cell">
                      <button
                        type="button"
                        class="btn btn-default btn-small {{if (eq @controller.savingId (concat 'extend-' fp.id)) 'disabled'}}"
                        {{on "click" (fn @controller.extendPurchase fp)}}
                      >
                        {{if (eq @controller.savingId (concat 'extend-' fp.id)) "Extending..." "Extend 30d"}}
                      </button>
                    </td>
                  </tr>
                {{else}}
                  <tr><td colspan="8" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">No featured purchases.</p>
                    </div></td></tr>
                {{/each}}
              {{/if}}
            </tbody>
          </table>
</div>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'edits')}}
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Provider</th>
                <th scope="col">Field</th>
                <th scope="col">Current</th>
                <th scope="col">Proposed</th>
                <th scope="col">Proposer</th>
                <th scope="col">Created</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#if @controller.editProposalsLoading}}
                <tr><td colspan="7" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">Loading edit proposals…</p>
                    </div></td></tr>
              {{else}}
                {{#each @controller.editProposals as |ep|}}
                  <tr>
                    <td><strong>{{ep.provider_name}}</strong></td>
                    <td>{{ep.field_name}}</td>
                    <td class="description-text">{{ep.current_value}}</td>
                    <td class="description-text">{{ep.proposed_value}}</td>
                    <td>{{ep.proposed_by}}</td>
                    <td class="description-text">{{ep.created_at}}</td>
                    <td class="pd-admin-actions-cell">
                      <button
                        type="button"
                        class="btn btn-primary btn-small {{if (eq @controller.savingId (concat 'approve-proposal-' ep.id)) 'disabled'}}"
                        {{on "click" (fn @controller.approveProposal ep)}}
                      >
                        Approve
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-small {{if (eq @controller.savingId (concat 'reject-proposal-' ep.id)) 'disabled'}}"
                        {{on "click" (fn @controller.rejectProposal ep)}}
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                {{else}}
                  <tr><td colspan="7" class="empty-results">
                    <div class="pd-empty-state">
                      <div class="pd-empty-icon">🔍</div>
                      <h3 class="pd-empty-title">No Results</h3>
                      <p class="pd-empty-description">No pending edit proposals.</p>
                    </div></td></tr>
                {{/each}}
              {{/if}}
            </tbody>
          </table>
        </div>
      {{/if}}
    </div>

  </template>
);
